export default __webpack_public_path__ + "static/media/uneb.fa2957a2.png";